import script from "./AlertInputConsecutive.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertInputConsecutive.vue?vue&type=script&setup=true&lang=ts"

import "./AlertInputConsecutive.vue?vue&type=style&index=0&id=67879a0b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67879a0b"]])

export default __exports__